// extracted by mini-css-extract-plugin
export default {"tabsContainer":"Tabs_tabsContainer__iyZum","tabButton":"Tabs_tabButton__qKk93","active":"Tabs_active__xd8zO"};